import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.PuzzleSlider;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "PuzzleSlider.Phaser.IntroductionScene.1",
            "PuzzleSlider.Phaser.IntroductionScene.2",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/PuzzleSlider/scenes/GameIntro.ts